/* eslint-disable @typescript-eslint/no-explicit-any */

import { ResizeBox } from "@/components/shared/resize-box";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import { cn } from "@/lib/utils";
import { Checkbox } from "@/components/ui/checkbox";
import { MultiSelectWithSearch } from "@/components/form-input";
import { TriangleIcon } from "lucide-react";
export const ReactTable = ({
  tableHeader,
  onResize,
  sortedKeys,
  value,
  customerMap,
  searchText,
  selectedForDeletion,
  handleToggleForDeletion,
  onChangeHandler,
  sku_list,
  sortKey,
  sortOrder,
  handleSorting,
  deleteSelectionToggle,
}: any) => {
  const isAllSelected = selectedForDeletion?.length === sortedKeys?.length;
  console.log({ sortedKeys });
  return (
    <Table style={{ borderCollapse: "collapse" }}>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[32px]">
            <Checkbox
              checked={sortedKeys?.length !== 0 ? isAllSelected : false}
              onCheckedChange={() => deleteSelectionToggle()}
              disabled={sortedKeys?.length === 0}
            />
          </TableHead>
          {tableHeader?.map((header: any, index: number) => {
            if (header.accessorKey === "sku") {
              return (
                <TableHead
                  key={header.accessorKey}
                  className={cn({ "pl-5": index === 0 })}
                >
                  {header.header}
                </TableHead>
              );
            }
            return (
              <TableHead
                key={header.accessorKey}
                style={{
                  width: header.width,
                  minWidth: header.minWidth,
                  maxWidth: header.maxWidth,
                }}
                className={cn({ "pl-5": index === 0 })}
                onClick={() => handleSorting(header.accessorKey)}
              >
                <ResizeBox
                  width={header.width}
                  onResize={(props: any) =>
                    onResize({ size: props, key: header.accessorKey })
                  }
                >
                  {header.header}
                  <span className="pl-2">
                    {sortKey === header.accessorKey ? (
                      <>
                        {sortOrder === "desc" ? (
                          <TriangleIcon
                            className={cn("")}
                            fill="#1f2937"
                            stroke="#1f2937"
                            size={8}
                          />
                        ) : (
                          <TriangleIcon
                            className={cn("rotate-180")}
                            fill="#1f2937"
                            stroke="#1f2937"
                            size={8}
                          />
                        )}
                      </>
                    ) : (
                      <span>
                        <TriangleIcon
                          fill="#1f2937"
                          stroke="#1f2937"
                          size={8}
                        />
                        <TriangleIcon
                          className={"rotate-180"}
                          fill="#1f2937"
                          stroke="#1f2937"
                          size={8}
                        />
                      </span>
                    )}
                  </span>
                </ResizeBox>
              </TableHead>
            );
          })}
        </TableRow>
      </TableHeader>
      <TableBody>
        {sortedKeys?.length
          ? sortedKeys.map((key: string, index: number) => {
              const propValue = value[key];
              const label = customerMap[key]
                ? `${customerMap[key]} (${key})`
                : key;
              if (
                searchText &&
                !label.toLowerCase().includes(searchText.toLowerCase()) &&
                !key.toLowerCase().includes(searchText.toLowerCase())
              ) {
                return null;
              }

              return (
                <tr key={index} className="mb-4">
                  <TableCell>
                    <Checkbox
                      id={`checkbox-${key}`}
                      checked={selectedForDeletion.includes(key)}
                      onCheckedChange={() => handleToggleForDeletion(key)}
                    />
                  </TableCell>
                  {tableHeader?.map((header: any, index: number) => {
                    if (header.accessorKey === "sku") {
                      return (
                        <TableCell key={header.accessorKey}>
                          {" "}
                          <MultiSelectWithSearch
                            value={Array.isArray(propValue) ? propValue : []}
                            onChange={(prop: any) => {
                              console.log({ key, prop });
                              onChangeHandler(key, prop);
                            }}
                            options={sku_list || []}
                            bindValue="sku_code"
                            bindLabel="sku_code"
                            noLimit={true}
                            placeholder="Select SKUs"
                          />
                        </TableCell>
                      );
                    }
                    return (
                      <TableCell
                        key={header.accessorKey}
                        style={{
                          width: header.width,
                          minWidth: header.minWidth,
                          maxWidth: header.maxWidth,
                        }}
                        className={cn(
                          { "pl-5": index === 0 },
                          header.accessorKey === "sku" ? "w-full" : "",
                        )}
                      >
                        {header.accessorKey === "customer_id" ? (
                          <>{key}</>
                        ) : null}
                        {header.accessorKey === "customer_name" ? (
                          <>{customerMap[key]}</>
                        ) : null}
                      </TableCell>
                    );
                  })}

                  {/* <ArrayInput
                          value={Array.isArray(propValue) ? propValue : []}
                          onChange={(prop: any) => {
                            console.log({ key, prop });
                            onChangeHandler(key, prop);
                          }}
                          unique={true}
                          placeholder="Press enter to add new item"
                        /> */}
                </tr>
              );
            })
          : null}
      </TableBody>
    </Table>
  );
};
